// Fonction pour générer un décalage aléatoire
function randomizeCoordinates(latlng, maxOffset = 0.01) {
    const lat = latlng.lat();
    const lng = latlng.lng();

    // Générer un décalage aléatoire pour la latitude et la longitude
    const latOffset = Math.random() * maxOffset * (Math.random() > 0.5 ? 1 : -1);
    const lngOffset = Math.random() * maxOffset * (Math.random() > 0.5 ? 1 : -1);

    // Appliquer le décalage aux coordonnées
    const newLat = lat + latOffset;
    const newLng = lng + lngOffset;

    return new google.maps.LatLng(newLat, newLng);
}

document.addEventListener('DOMContentLoaded', function () {
    let mapElement = document.getElementById("map");
    if (mapElement) {
        const map = new google.maps.Map(mapElement, {
            center: { lat: 46.84779206569178, lng: 2.661127156250016 },
            zoom: 6,
        });

        const infowindow = new google.maps.InfoWindow();
        const geocoder = new google.maps.Geocoder();

        let markers = [];

        // Fonction utilitaire pour géocoder une adresse et créer un marqueur
        function geocodeAndCreateMarker(coachElement) {
            return new Promise((resolve, reject) => {

                let productId = coachElement.id;
                // Récupérer les informations du coach à partir des attributs data-*
                let coachPhoto = coachElement.getAttribute('data-img');
                // let coachNom = coachElement.getAttribute('data-nom');
                // let coachProductLink = coachElement.getAttribute('data-product');
                let coachCp = coachElement.getAttribute('data-cp');
                let coachAddress = coachElement.getAttribute('data-adress');
                let address = coachCp + ' ' + coachAddress;

                geocoder.geocode({ address: address }, (results, status) => {
                    if (status === 'OK' && results.length > 0) {
                        let location = results[0].geometry.location;

                        // let contentString = `
                        //     <div class="info-window">
                        //         <div class="coach-nom">${coachNom}</div>
                        //         <div class="coach-cp">${coachCp}</div>
                        //         <div class="coach-ville">${coachAddress}</div>
                        //         <div class="coach-lien"><a href="${coachProductLink}">Voir le produit</a></div>
                        //     </div>
                        // `;

                        let marker = new google.maps.Marker({
                            position: randomizeCoordinates(location),
                            icon: {
                                url: coachPhoto,
                                size: new google.maps.Size(48, 48),
                                scaledSize: new google.maps.Size(48, 48),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(24, 48)
                            },
                            map: map
                        });


                        // Ajout d'un écouteur d'événement au marqueur pour afficher l'info-bulle au clic
                        marker.addListener('click', function () {
                            // infowindow.setContent(contentString);
                            // infowindow.open(map, marker);
                            document.querySelectorAll('.profil-coach').forEach(coachElement => {
                                coachElement.classList.remove('visible');
                            });
                            document.getElementById(productId).classList.toggle('visible');
                        });

                        markers.push(marker);
                        resolve(marker);
                    } else {
                        reject(new Error('Geocoding failed'));
                    }
                });
            });
        }

        // Récupération de tous les éléments coach et géocodage en utilisant Promise.all
        let coachPromises = Array.from(document.querySelectorAll('.profil-coach')).map(geocodeAndCreateMarker);

        // Attendez que toutes les promesses soient résolues avant d'initialiser MarkerClusterer
        Promise.all(coachPromises)
            .then(() => {
                // Une fois que tous les marqueurs sont créés, initialisez MarkerClusterer
                new markerClusterer.MarkerClusterer({
                    map: map,
                    markers: markers
                });
            })
            .catch(error => {
                console.error('Error creating markers:', error);
            });
    }
});
